var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plk-basic-container"},_vm._l((_vm.componentsWithInstance),function(object,index){return _c('ObjectLoader',{key:`${Math.random()}-${index}`,attrs:{"object":object,"connection":object.connection,"plkparams":object.plkparams,"instance":_vm.getInstance(object.type)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }